import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY, SUPABASE_ENABLED } from './envConfig';

if (!SUPABASE_ENABLED) {
  console.error('❌ Supabase non configuré. Vérifiez VITE_PUBLIC_SUPABASE_URL et VITE_PUBLIC_SUPABASE_ANON_KEY dans .env');
}

/**
 * Client Supabase unique (singleton)
 * Utilisé dans toute l'application pour l'auth et les données
 */
export const supabase = createClient(
  SUPABASE_URL || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);

/**
 * Vérifie si Supabase est correctement configuré
 * @returns true si configuré, false sinon
 */
export function isSupabaseConfigured(): boolean {
  return SUPABASE_ENABLED;
}